import { handleVisualizationStateFail, handleVisualizationStateStart, handleVisualizationStateSuccess } from './fetchVisualization';

// Some visualization APIs serve both the single-round section and its trend
// counterpart, told apart by `additonalFilters.isTrendComparison` on the
// request. Each keeps its own slice so the trend call never overwrites the
// regular one.
const createTrendAwareHandlers = (apiName, trendApiName) => {
    const stateKeyFor = (request) => (
        request && request.additonalFilters && request.additonalFilters.isTrendComparison ? trendApiName : apiName
    );

    return {
        start: (state, payload) => (
            handleVisualizationStateStart(state, { ...payload, apiName: stateKeyFor(payload) })
        ),
        // SUCCESS carries the original request under `payload`.
        success: (state, payload) => (
            handleVisualizationStateSuccess(state, { ...payload, apiName: stateKeyFor(payload && payload.payload) })
        ),
        // FAIL spreads the request alongside the error.
        fail: (state, payload) => (
            handleVisualizationStateFail(state, { ...payload, apiName: stateKeyFor(payload) })
        ),
    };
};

// getRaterHeatmap → fetchRaterHeatmapApi / fetchTrendRaterHeatmapApi
const raterHeatmap = createTrendAwareHandlers('fetchRaterHeatmapApi', 'fetchTrendRaterHeatmapApi');
export const fetchRaterHeatmapStart = raterHeatmap.start;
export const fetchRaterHeatmapSuccess = raterHeatmap.success;
export const fetchRaterHeatmapFail = raterHeatmap.fail;

// getSelfVsOthers → fetchSelfVsOthersApi / fetchTrendSelfVsOthersApi (What moved most)
const selfVsOthers = createTrendAwareHandlers('fetchSelfVsOthersApi', 'fetchTrendSelfVsOthersApi');
export const fetchSelfVsOthersStart = selfVsOthers.start;
export const fetchSelfVsOthersSuccess = selfVsOthers.success;
export const fetchSelfVsOthersFail = selfVsOthers.fail;

// getTopStrengthTopDev → fetchTopStrengthAndTopDevApi / fetchTrendTopStrengthAndTopDevApi (Strengths and growth movement)
const topStrengthTopDev = createTrendAwareHandlers('fetchTopStrengthAndTopDevApi', 'fetchTrendTopStrengthAndTopDevApi');
export const fetchTopStrengthTopDevStart = topStrengthTopDev.start;
export const fetchTopStrengthTopDevSuccess = topStrengthTopDev.success;
export const fetchTopStrengthTopDevFail = topStrengthTopDev.fail;
